import { Component } from "react";

class O extends Component {
	render() {
		return (
			<svg
        xmlns="http://www.w3.org/2000/svg"
        width="80%"
        height="80%"
        viewBox="0 0 10 10.5"
        stroke="#bbdb9b"
        fill="transparent"
      >
        <circle cx="5" cy="5.5" r="4.5" stroke="#abc4a1" />
        <circle cx="5" cy="5" r="4.5" />
      </svg>
		)
	}
}

export { O }
